<template>

  <div>
    <data-table
      :title="'Backhaul ' + (this.sharerId ? 'Customers' : 'Providers')"
      icon="fa fa-wifi"

      table-ref="backhaultable"

      :url="'/backhaul' + (this.provider ? '' : '/subscribers')
      + (this.siteId ? '/site/' + Number(this.siteId) : '') + (this.sharerId ? '/org/' + Number(this.sharerId) : '')"

      :fields="backhaulFields"

      :add-action="!isTowerCo() || noAdd ? null : showProviderSelect ? selectProvider : addBackhaul"
      :add-props="!isTowerCo() || noAdd ? null : addProps"

      :hide-org-badge="this.siteId ? true : false"

      sort-field="backhaulType"
      search-placeholder="Providers, Site Names..."

      :detail-component="(!isTowerCo()) ? null :
      (provider
        ? 'backhaul-provider-row'
        : 'backhaul-customer-row')">

      <template slot="subscribers" slot-scope="props">
        <span v-html>{{formatUsers(props)}}</span>
      </template>
<!--
      <template slot="addCustomer" slot-scope="props">
        <backhaul-action
          v-if="!hasThisSharer(this.sharerId, props)"
          :site-id="siteId"
          :site-name="siteName"
          :sharer-id="sharerId"
          :site-data="siteData"
          :provider="provider" />
      </template>
-->
    </data-table>

    </div>
</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

import BackhaulAction from '@/components/actions/BackhaulAction'

import SelectBackhaulProvider from '@/components/atoms/selects/SelectBackhaulProvider'
import BackhaulProvider from '@/components/backhaul/BackhaulProvider'
import BackhaulCustomer from '@/components/backhaul/BackhaulCustomer'

import BackhaulControls from '@/components/backhaul/BackhaulControls'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

Vue.component('backhaul-provider-row', BackhaulProvider)
Vue.component('backhaul-customer-row', BackhaulCustomer)

Vue.use(VueEvents)
Vue.component('backhaul-controls', BackhaulControls)

export default {

  mixins: [DateMixins, NumberMixins],

  components: {
    BackhaulAction,
    SelectBackhaulProvider
  },


  props: {

    siteId: {
      type: Number,
      default: null
    },

    siteName: {
      type: String,
      default: null
    },

    provider: {
      type: Boolean,
      default: true
    },

    sharerId: {
      type: Number,
      default: null
    },

    siteData: {
      type: Object,
      default: null
    },

    showProviderSelect: {
      type: Boolean,
      default: false
    },

    noAdd: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },



  watch: {

    sharer: function (value) {
      this.telcoId = value
      this.$refs.backhaultable.refresh()
    }

  },



  methods: {

    formatStatus (value, inclText = false) {
      var icon = ''
      var color = 'darkgrey'

      if (value === 'Completed') {
        color = 'seagreen'
        icon = 'check-square'
      }

      if (value === 'KIV') {
        icon = 'clock'
      }

      if (value === 'Pending Payment') {
        color = 'goldenrod'
        icon = 'credit-card'
      }

      if (value === 'Approved') {
        color = 'seagreen'
        icon = 'thumbs-up'
      }

      if (value === 'Active') {
        color = 'slateblue'
        icon = 'check'
      }

      if (value === 'Terminated') {
        color = 'indianred'
        icon = 'bolt'
      }

      if (value === 'Pending') {
        color = 'goldenrod'
        icon = 'random'
      }

      return '<b><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '&nbsp;</i><span style="color: ' + color + ';">&nbsp;' +
        (this.isMobile ? '' : (inclText ? value : '')) +
        '</span></b>'
    },

    formatProvider (value) {
      if (value) {
        return '<b class="text-success">' + value + '</b>'
      } else {
        return ''
      }
    },

    formatUsers (value) {
      if (value && this.provider) {
        let users = []

        if ((!this.isTowerCo() && !this.isBackhaulCo()) && value.length > 0) {
          users.push(`Total: ${value.length}`)
        }

        for (var i = 0; i < value.length; i++) {

          let name = value[i].organisation.shortName
          let orgId = value[i].organisation.id

          if (this.isMobile) {
            name = name.toUpperCase().substring(0, 1)
          } else {
            name = name.toUpperCase().substring(0, 3)
          }

          if (this.isTowerCo() || this.isBackhaulCo()) {
            users.push(name)
          } else {

            if (this.sharerId === orgId) {
              users.push(name)
            }

          }
        }
        return '<b>' + users + '</b>'

      } else {

        if (value && value.rowData) {
          return '<b>' + value.rowData.sharer.shortName + '</b>'

        } else {
          return ''

        }
      }

    },

    hasThisSharer (id, rowData) {
      return false
    }

  },



  data () {

    return {
      telcoId: this.sharer,

      addBackhaul: BackhaulAction,
      selectProvider: SelectBackhaulProvider,

      addProps: {
        siteId: this.siteId,
        siteName: this.siteName,
        sharerId: this.sharerId,
        siteData: this.siteData,
        provider: this.provider,
        readOnly: this.readOnly
      },

      backhaulFields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'site.siteId',
          title: 'Site Id',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          visible: !this.siteId
        },
        {
          name: 'site.siteName',
          title: 'Site Name',
          visible: !this.siteId
        },
        {
          name: 'status',
          title: 'Status',
          callback: this.formatStatus
        },
        {
          name: 'provider.shortName',
          title: 'Provider',
          callback: this.formatProvider
        },
        {
          name: this.sharerId ? 'backhaul.backhaulType' : 'backhaulType',
          title: 'Type'
        },
/*        {
          name: '__slot:subscribers',
          title: 'Customer',
          visible: this.sharerId
        }, */
        {
          name: 'active',
          title: 'Customers',
          callback: this.formatUsers,
          visible: this.isTowerCo() || this.isBackhaulCo()
        },
        {
          name: 'depositFee',
          title: 'Entrance',
          sortField: 'depositFee',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber,
          visible: this.canAccess('finance')
        },
        {
          name: 'rightOfWayCharges',
          title: 'RoW',
          sortField: 'rightOfWayCharges',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          callback: this.formatNumber,
          visible: this.canAccess('finance')
        },
        {
          name: 'started',
          title: 'Started',
          sortField: 'tenor',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate,
          visible: this.isTowerCo() && !this.sharerId
        },
        {
          name: 'expiry',
          title: 'Expiry',
          sortField: 'tenor',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          callback: this.formatDate,
          visible: this.isTowerCo() && !this.sharerId
        },
        {
          name: '__component:backhaul-controls',
          title: '',
          visible: !this.showProviderSelect
        }

/*
        {
          name: '__slot:addCustomer',
          visible: this.isTowerCo() && !this.provider
        }
*/
      ]
    }
  }

}
</script>



// WEBPACK FOOTER //
// BackhaulTable.vue?a4b27478